(() => {
  // One native product form per PDP. Sticky bar, closing CTA and fact tiles only proxy it and mirror its price / unit price.
  const STICKY = '[data-drf-pdp-sticky]';
  const PROXY = '[data-drf-pdp-proxy]';
  const observed = new WeakSet();

  const clean = (text) => (text || '').replace(/\s+/g, ' ').trim();

  function getNative(handle) {
    const productRoot = document.querySelector(`[data-drf-pdp-shell][data-product-handle="${CSS.escape(handle)}"], .product-section[data-product-handle="${CSS.escape(handle)}"]`);
    const form = productRoot?.querySelector('form[data-product-form]');
    const primary = form?.querySelector('button[data-add-to-cart]');
    if (!productRoot || !form || !primary) return null;
    return { productRoot, form, primary };
  }

  function readUnit(productRoot) {
    const wrapper = productRoot.querySelector('[data-product-unit]');
    const amount = productRoot.querySelector('[data-product-unit-price]');
    const base = productRoot.querySelector('[data-product-base]');
    if (!wrapper || !amount || wrapper.style.display === 'none') return '';
    return clean(`${clean(amount.textContent)} / ${clean(base?.textContent)}`);
  }

  function sync(handle, native) {
    const { productRoot, primary } = native;
    const scope = `[data-product-handle="${CSS.escape(handle)}"]`;
    const price = clean(productRoot.querySelector('[data-product-price]')?.textContent);
    const unit = readUnit(productRoot);

    if (price) document.querySelectorAll(`${scope} [data-drf-sync-price], [data-drf-sync-price]${scope}`).forEach((el) => { el.textContent = price; });
    document.querySelectorAll(`${scope} [data-drf-sync-unit], [data-drf-sync-unit]${scope}`).forEach((el) => {
      if (unit) el.textContent = unit;
      el.hidden = !unit;
    });
    document.querySelectorAll(`${PROXY}${scope}`).forEach((proxy) => {
      const label = proxy.dataset.drfLabel || (window.drfStrings && window.drfStrings.addToCart) || 'In den Warenkorb';
      if (proxy.tagName === 'BUTTON') proxy.disabled = primary.disabled;
      proxy.setAttribute('aria-disabled', String(primary.disabled));
      proxy.textContent = primary.disabled ? clean(primary.textContent) : label;
    });
  }

  function observe(handle, native) {
    if (observed.has(native.productRoot)) return;
    observed.add(native.productRoot);
    const run = () => sync(handle, native);
    native.form.addEventListener('change', () => requestAnimationFrame(run));
    new MutationObserver(run).observe(native.productRoot, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['disabled', 'style']
    });
    run();
  }

  function initProxies(root = document) {
    root.querySelectorAll(PROXY).forEach((proxy) => {
      if (proxy.dataset.drfInitialized === 'true') return;
      const handle = proxy.dataset.productHandle;
      const native = handle && getNative(handle);
      if (!native) return;
      proxy.dataset.drfInitialized = 'true';
      proxy.addEventListener('click', (event) => {
        event.preventDefault();
        if (!native.primary.disabled) native.primary.click();
      });
      observe(handle, native);
      sync(handle, native);
    });
  }

  function initSticky(root = document) {
    root.querySelectorAll(STICKY).forEach((bar) => {
      if (bar.dataset.drfInitialized === 'true') return;
      const handle = bar.dataset.productHandle;
      const native = handle && getNative(handle);
      if (!native) return;
      bar.dataset.drfInitialized = 'true';

      const updateVisibility = () => {
        const mobile = window.matchMedia('(max-width: 767px)').matches;
        const above = native.primary.getBoundingClientRect().bottom < 0;
        const show = mobile && above;
        bar.hidden = !show;
        bar.setAttribute('aria-hidden', String(!show));
        document.body.classList.toggle('drf-pdp-sticky-active', show);
      };

      window.addEventListener('scroll', updateVisibility, { passive: true });
      window.addEventListener('resize', updateVisibility);
      observe(handle, native);
      updateVisibility();
    });
  }

  function init(root) {
    initProxies(root);
    initSticky(root);
  }

  document.addEventListener('DOMContentLoaded', () => init(document));
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();